import { render, staticRenderFns } from "./LPTemp1.vue?vue&type=template&id=9fb2fa16&scoped=true&"
import script from "./LPTemp1.vue?vue&type=script&lang=js&"
export * from "./LPTemp1.vue?vue&type=script&lang=js&"
import style0 from "./LPTemp1.vue?vue&type=style&index=0&id=9fb2fa16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb2fa16",
  null
  
)

export default component.exports